const actions = {
  open_popup ({ commit }, config) {
    commit('OPEN_POPUP', config)
  },
  close_popup ({ commit }) {
    commit('CLOSE_POPUP')
  }
}

export default actions
